"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = exports.Breakpoints = void 0;
const react_1 = require("react");
// Importing the polyfilled version of ResizeObserver
// eslint-disable-next-line import/no-internal-modules
const polyfilled_1 = __importDefault(require("use-resize-observer/polyfilled"));
const throttle_1 = __importDefault(require("lodash/throttle"));
exports.Breakpoints = {
    base: 640,
    small: 500,
    smaller: 265,
    large: 750,
    larger: 1024,
};
const wait = 100;
function useResizeObserver({ widths = exports.Breakpoints, heights = exports.Breakpoints, } = {}) {
    const [exactSize, setSize] = (0, react_1.useState)({
        width: undefined,
        height: undefined,
    });
    const onResize = (0, react_1.useMemo)(() => (0, throttle_1.default)(setSize, wait), [wait]);
    const { ref } = (0, polyfilled_1.default)({
        onResize,
    });
    const exactWidth = exactSize.width;
    const exactHeight = exactSize.height;
    const sizes = {
        width: getSize(widths, exactSize.width),
        height: getSize(heights, exactSize.height),
        exactWidth,
        exactHeight,
    };
    return [ref, sizes];
}
exports.useResizeObserver = useResizeObserver;
/**
 * To get the proper size we want to make sure that our value is greater
 * then the comparable, but less then the next largest number in our
 * object.
 */
function getSize(sizes, comparable) {
    if (!comparable || !sizes) {
        return undefined;
    }
    /**
     * Sort the values of our object so that we know they are in proper
     * order to be compared by
     */
    const sortedSizes = Object.values(sizes)
        .sort((a, b) => a - b)
        .reverse();
    return (sortedSizes.find(value => value <= comparable) ||
        sortedSizes[sortedSizes.length - 1]);
}
